export const selectAccessCode = (state) => state.accessCode;

export const selectWholesalerAccessCode = (state) =>
  selectAccessCode(state).wholesalerAccessCodes;
